export const errors = [
    { code: 100, message: 'Útgefandi kortsins leyfir ekki þessa aðgerð' },
    { code: 101, message: 'Gildistími þessa korts er liðinn' },
    { code: 102, message: 'Korti þessu er ekki treystandi' },
    { code: 103, message: 'Merchant call acquirer	01, 66, 08' },
    { code: 104, message: 'Þetta kort hefur verið takmarkað af útgefanda' },
    { code: 106, message: 'Hámark PIN innsetninga hefur verið náð' },
    { code: 109, message: 'Sölustaður svarar ekki, vinsamlegast hafðu samband við Matvinnu eða reyndu aftur síðar.' },
    { code: 110, message: 'Upphæð ólögleg, vinsamlegast hafðu samband við Matvinnu eða reyndu aftur síðar.' },
    { code: 111, message: 'Kortanúmer er ekki gilt' },
    { code: 112, message: 'Vantar PIN númer' },
    { code: 116, message: 'Því miður fékkst ekki heimild fyrir þessari færslu' },
    { code: 117, message: 'PIN númer ekki rétt' },
    { code: 118, message: 'Unknown card	' },
    { code: 119, message: 'Kortahafi hefur lokað fyrir þessa færslu.' },
    { code: 120, message: 'Féhirðir hefur lokað fyrir þessa færslu, vinsamlegast hafðu samband við Matvinnu eða reyndu aftur síðar.' },
    { code: 121, message: 'Exceeds limits to withdrawal	61, 65' },
    { code: 125, message: 'Greiðslukort ekki gilt' },
    { code: 126, message: 'False PIN block	' },
    { code: 129, message: 'Suspected fraud	' },
    { code: 130, message: 'Invalid Track2	' },
    { code: 131, message: 'Invalid Expiration Date	' },
    { code: 161, message: 'DCC transaction not allowed to cardholder	' },
    { code: 162, message: 'DCC cardholder currency not supported	' },
    { code: 163, message: 'DCC exceeds time limit for withdrawal	' },
    { code: 164, message: 'DCC transaction not allowed to terminal	' },
    { code: 165, message: 'DCC not allowed to merchant	' },
    { code: 166, message: 'DCC unknown error	' },

    { code: 200, message: 'No not honor	04' },
    { code: 201, message: 'Card not valid	33' },
    { code: 202, message: 'Korti þessu er ekki treystandi' },
    { code: 203, message: 'Merchant contact acquirer	37' },
    { code: 204, message: 'Limited card	36' },
    { code: 205, message: 'Merchant contact police	' },
    { code: 206, message: 'Allowed PIN-retries exceeded	38' },
    { code: 207, message: 'Special occasion	' },
    { code: 208, message: 'Lost card	41' },
    { code: 209, message: 'Stolen card	43' },
    { code: 210, message: 'Suspected fraud	' },
    { code: 902, message: 'False transaction	89, 06' },
    { code: 904, message: 'Form error	30' },
    { code: 907, message: 'Issuer not responding	' },
    { code: 908, message: 'Message can not be routed	15, 80, 81,' },
    { code: 909, message: 'System error	83, 96' },
    { code: 910, message: 'Issuer did not respond	68' },
    { code: 911, message: 'Issuer timed out	82' },
    { code: 912, message: 'Issuer not reachable	91' },
    { code: 913, message: 'Double transaction transmission	94' },
    { code: 914, message: 'Original transaction can not be traced	' },
    { code: 916, message: 'Merchant not found	' },
    { code: 950, message: 'No financial record found for detail data	' },
    { code: 951, message: 'Batch already closed	' },
    { code: 952, message: 'Invalid batch number	' },
    { code: 953, message: 'Host timeout	' },
    { code: 954, message: 'Batch not closed	' },
    { code: 955, message: 'Merchant not active	' },
    { code: 956, message: 'Transaction number not unique	' },
    { code: 997, message: 'Action code exclusive to RPG and indicates a network communication problem.' },
    { code: 998, message: 'Action code exclusive to RPG and indicates a form error (See ActionCode: 904' },
    { code: 999, message: 'Action code exclusive to RPG and indicates a system error.' },
]

export const messageByCode = code => {
    let err = errors.find(e => e.code == code);
    return err ? err.message : 'Villa kom upp við skráningu, vinsamlegast reyndu aftur.';
};


// WEBPACK FOOTER //
// ./src/services/utils/BorgunErrors/index.js